// @flow

import Game from '@/lib/game';
import Unit from '@/lib/unit';
import Cell from '@/lib/cell';
import Settings from '@/lib/settings';

export default class {
  game: Game;
  lastUnitId: number;
  units: { [number]: Unit };
  dictionary: string[];
  diversityLevel: number;
  diversityRank: string = 'F';

  constructor(game: Game) {
    this.game = game;
    this.lastUnitId = 0;
    this.units = {};
    this.dictionary = [];
  }

  getDiversityRank(diversityLevel: number): string {
    if (diversityLevel > 0.9) return 'S';
    if (diversityLevel > 0.8) return 'A';
    if (diversityLevel > 0.7) return 'B';
    if (diversityLevel > 0.5) return 'C';
    if (diversityLevel > 0.3) return 'D';
    if (diversityLevel > 0.1) return 'E';
    return 'F';
  }

  createUnit(unitTemplate: UnitTemplate, cell: Cell): Unit {
    this.lastUnitId++;
    const unit = new Unit({
      manager: this,
      id: this.lastUnitId,
      template: unitTemplate,
      cell: cell,
    });
    this.units[unit.id] = unit;
    this.registerDictionary(unitTemplate);
    return unit;
  }

  find(...conditions: any[]): Unit | null {
    switch (conditions.length) {
      case 1:
        return this.units[conditions[0]] || null;
    }

    return null;
  }

  registerDictionary(unitTemplate: UnitTemplate) {
    if (!unitTemplate.categories || unitTemplate.categories.includes('weed'))
      return;

    const templateType = this.dictionary.find(
      templateType => templateType === unitTemplate.type
    );

    if (typeof templateType === 'undefined') {
      this.dictionary.push(unitTemplate.type);
    }
  }

  process() {
    // 日光量計算のため樹高の降順でキーをソートする
    const sortedUnitIds = Object.keys(this.units).sort((a, b) =>
      Math.sign(
        this.units[Number(b)].treeHeight - this.units[Number(a)].treeHeight
      )
    );

    sortedUnitIds.forEach(unitId => {
      const unit = this.units[Number(unitId)];
      if (!unit) return;
      unit.process();
      this.tryDelete(unit);
    });

    this.diversityLevel = this.calculateDiversityLevel();
    this.diversityRank = this.getDiversityRank(this.diversityLevel);
  }

  tryDelete(unit: Unit) {
    if (unit.isDead() || unit.isCut()) {
      unit.deadTime++;
      if (Settings.unitZonbieTime < unit.deadTime) delete this.units[unit.id];
    }
  }

  /**
   * 多様性指数を慶安する
   * TODO: 本来はここは正規表現など使わず
   * UnitTemplate に正規化された適切なデータとして用意したい
   */
  calculateDiversityLevel(): number {
    const counts: { [string]: number } = {};
    let totalCount = 0;
    Object.keys(this.units).forEach(unitId => {
      const unit = this.units[Number(unitId)];
      const type = unit.template.type;

      // 若木、成木のみに絞る
      const matched = type.match(/(.+?)(_young|_adult)$/);
      if (!matched) return;

      const key = matched[1];
      counts[key] ? counts[key]++ : (counts[key] = 1);

      totalCount++;
    });

    const variationLevel = totalCount
      ? 1 -
        Object.keys(counts).reduce((acc: number, key: string) => {
          const count = counts[key];
          return acc + Math.pow(count / totalCount, 2);
        }, 0)
      : 0;
    return variationLevel;
  }
}



// WEBPACK FOOTER //
// ./src/lib/unit_manager/unit_manager.js